import {
  PublicEventStatusDto,
  type EventListItemDto,
  type ListBuyerEventsApiArg,
} from "../../autogen/bff-api";
import type { EventStatusInput } from "../../common/sourcing-events/EventStatusTag";

type EventStatusFilter = NonNullable<ListBuyerEventsApiArg["statuses"]>;

// Wound up: awarded, cancelled or otherwise finished. Nothing is expected of the buyer any more.
const TERMINAL_PUBLIC_EVENT_STATUSES: PublicEventStatusDto[] = [
  PublicEventStatusDto.Awarded,
  PublicEventStatusDto.Cancelled,
  PublicEventStatusDto.Closed,
  PublicEventStatusDto.Completed,
];

/**
 * Active = neither a draft nor finished. Derived by subtraction rather than listed, so a status added
 * to the API later shows up on the home instead of silently vanishing from it — the same rule the BFF
 * applies in `SourcingEventStatus.isActive`.
 *
 * PUBLICATION_PENDING and PUBLICATION_FAILED land here: the buyer has committed to announcing, and a
 * failed Doffin publish needs attention rather than sitting quietly among the drafts.
 */
export const ACTIVE_EVENT_STATUSES: EventStatusFilter = Object.values(PublicEventStatusDto).filter(
  (status) => status !== PublicEventStatusDto.Draft && !TERMINAL_PUBLIC_EVENT_STATUSES.includes(status)
);

export const DRAFT_EVENT_STATUSES: EventStatusFilter = [PublicEventStatusDto.Draft];

export const TERMINAL_EVENT_STATUSES: EventStatusFilter = TERMINAL_PUBLIC_EVENT_STATUSES;

export const eventStatusTagInput = (event: EventListItemDto): EventStatusInput | null =>
  event.publicStatus ? { kind: "PUBLIC", status: event.publicStatus } : null;

export const listItemIsDraft = (event: EventListItemDto): boolean =>
  event.publicStatus === PublicEventStatusDto.Draft;

export const listItemIsAwarded = (event: EventListItemDto): boolean =>
  event.publicStatus === PublicEventStatusDto.Awarded;

const SOON_DAYS = 3;
export const isDeadlineSoon = (deadline: string | null | undefined): boolean => {
  if (!deadline) return false;
  const ms = new Date(deadline).getTime() - Date.now();
  return ms >= 0 && ms <= SOON_DAYS * 86400000;
};
